import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useCptUploadStore } from './uploadQueue'

const CptUploadProgressBar = () => {
  const { tid } = useParams<{ tid: string }>()
  const waiting = useCptUploadStore(
    (s) =>
      s.jobs.filter(
        (job) =>
          (!tid || job.tid === tid) && job.status !== 'error',
      ).length,
  )
  const completed = useCptUploadStore((s) => s.waveCompleted)
  const total = useCptUploadStore((s) => s.waveTotal)

  useEffect(() => {
    if (waiting === 0) return
    const onLeave = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', onLeave)
    return () => window.removeEventListener('beforeunload', onLeave)
  }, [waiting])

  if (waiting === 0 || total === 0) return null

  const percent = Math.round((completed / total) * 100)

  return (
    <div
      className="flex min-w-[140px] max-w-[220px] flex-1 items-center gap-2"
      title="组件图片上传中，完成前请勿退出页面"
    >
      <div className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full bg-primary transition-all duration-200"
          style={{ width: `${Math.max(completed > 0 ? 6 : 0, percent)}%` }}
        />
      </div>
      <span className="shrink-0 text-xs tabular-nums text-muted-foreground">
        {completed}/{total}
      </span>
    </div>
  )
}

export default CptUploadProgressBar
